import axios from './_akdeAxios'

export const obtenerToken = async info => {
    const data = axios.post(`/Auth/request-token`, info, {
        headers: {
            'Content-Type': 'application/json',
        }
    })
    return data
}

export const getUserInfo = ruc => axios.get(`/Contasoft/user-info`, {
    params: { document: ruc }
})

export const getPayments = userName => axios.get(`/Contasoft/pending-payments`, {
    params: { userName: userName }
})

export const notifyPayment = data => axios.post('/Contasoft/notify-payment', data)